// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+HItp","titleWrapper":"styles_titleWrapper__qJZPQ","icon":"styles_icon__z9D0n","title":"styles_title__z4OdV","desc":"styles_desc__+wTq-"};